export class LocationLookup {
  id!: string;
  name!: string;
  locationId!: string;
  address!: string;
  locationName!: string;
  locationNameAndAddress!: string;
  sequenceNumber: number | undefined;
  displayName : string | undefined;
}
